export enum RequestStates {
Request,
Approved,
Rejected,
Correction,
}
